import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import LocaleTooling from '../../../tooling/localeTooling';
import { intl } from '../../../locales/localesConfig';

import toastr from 'toastr';

/* Actions */
import * as calculationsHistoryActions from '../../actions/calculationsHistory/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import Spinner from '../../components/common/interface/spinner';
import Filters from '../../components/calculationsHistory/filters';
import Header from '../../components/calculationsHistory/header';
import EntityTable from '../../components/common/entity/entityTable';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import CalculationDetailPopupContainer from './calculationDetailPopupContainer';
import DeleteCalculationInstancesDetailPopup from '../../components/calculationsHistory/deleteCalculationInstancesDetailPopup';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  calculationDetailPopup: "calculationDetailPopup",
  deleteCalculationInstancesDetailPopup: "deleteCalculationInstancesDetailPopup",
  deleteCalculationInstanceConfirmPopup: "deleteCalculationInstanceConfirmPopup"
}

class CalculationsHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: { //not used
        searchText: '',
        showDisabledEntities: false,
      },
      calculationsFilters: {
        filterGroup: "",
        criteria: Constants.calculationFilters.calculationUnitFilter.ALL,
        calculationUnitsSelected: [],
        filterPolynomial: "",
        filterPeriod: "",
        showOnlyWithErrorsFilter: false
      },
      calculationsFiltersActive: {},
      filtersText: "",
      tableDescriptor: TableDescriptors.calculationsHistoryList,
      filtersCollapse: false,
      activeCalculationInstanceObject: null
    };
  }
 
  async componentDidMount() {
    await this.props.actions.getPeriodsList();
    await this.props.actions.getPolynomialsList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {    
    //handle export calculations feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.exportCalculations.status],
      [this.props.exportCalculations.status],
      intl.formatMessage({ id: "calculationsHistory.exportCalculationsSuccess" }),
      intl.formatMessage({ id: "calculationsHistory.exportCalculationsFailure" })
    );
    
    //handle delete calculation instance feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.deleteCalculationInstance.status],
      [this.props.deleteCalculationInstance.status],
      this.props.deleteCalculationInstance.id ? 
        intl.formatMessage({ id: "calculationsHistory.deleteCalculationInstanceSuccess" }) :
        intl.formatMessage({ id: "calculationsHistory.deleteAllCalculationInstanceDetailSuccess" }),
      this.props.deleteCalculationInstance.status==423 ?
        intl.formatMessage({ id: "common.errors.systemLockedError" }) :
        intl.formatMessage({ id: "calculationsHistory.deleteCalculationInstanceError" }),
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.deleteCalculationInstanceConfirmPopup])) {
          InterfaceTooling.popupHide(popupIds.deleteCalculationInstanceConfirmPopup, this.setState.bind(this));
        }
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.deleteCalculationInstancesDetailPopup])) {
          InterfaceTooling.popupHide(popupIds.deleteCalculationInstancesDetailPopup, this.setState.bind(this));
        }
        this.setState({
          activeCalculationInstanceObject: null
        });
        EntityTableTooling.fetchList(this);
      }]    
    );
    
    if(this.props.periodsList.status===200 && prevProps.periodsList.status !==200) {
      if(this.props.periodsList.data.length > 0) {
        let selectedPeriod = this.props.periodsList.data[0]
        let periodIdSelected = selectedPeriod.id;
        if(this.props.match.params.periodId) {
          selectedPeriod = this.props.periodsList.data.find(item => item.id==this.props.match.params.periodId);
          periodIdSelected = selectedPeriod ? selectedPeriod.id : "";
        } 
        if(this.props.fixedPeriodId!="") {
          selectedPeriod = this.props.periodsList.data.find(item => item.id==this.props.fixedPeriodId);
          periodIdSelected = selectedPeriod ? selectedPeriod.id : "";
        }
        this.state.calculationsFilters.filterPeriod = periodIdSelected;
        if(periodIdSelected) {
          this.props.actions.getGroupsList(periodIdSelected);
        }
      }
    }
  }
  
  getListQueryParams(defaultQueryParams) {
    let newQueryParams = defaultQueryParams;
    newQueryParams.period_id = this.state.calculationsFiltersActive.filterPeriod;
    newQueryParams.group_id = this.state.calculationsFiltersActive.filterGroup;
    newQueryParams.polynomial_id = this.state.calculationsFiltersActive.filterPolynomial;
    newQueryParams.calculation_units_criteria = this.state.calculationsFiltersActive.criteria;
    newQueryParams.calculation_units = this.state.calculationsFiltersActive.calculationUnitsSelected.map(item => item.id);
    newQueryParams.show_only_errors = this.state.calculationsFiltersActive.showOnlyWithErrorsFilter;
    return newQueryParams;
  }
  
  handleOnChangeCalculationsFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    let value = this.state.calculationsFilters[path];
    let calculationsFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.calculationsFilters);
    
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;
      
      let calculation_units = calculationsFiltersNew[path]
            
      if(isDelete) { 
        delete calculation_units[index];
        calculation_units = calculation_units.filter(item => item);
      } else {
        var selectedItem = this.props.calculationUnitsFilter.data.find(item => item.id==listValue);
        var exists = this.state.calculationsFilters.calculationUnitsSelected.find(item => item.id==listValue);
        if(selectedItem && !exists) {
          calculation_units.push({id: listValue, name: selectedItem.name });
        }
        else if(exists) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.warning(LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage( {id: "calculationsHistory.calculationUnitAlreadyAdded"})),""); 
        }
      }
      value = calculation_units;
    }
    else {
      value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    }
    calculationsFiltersNew[path] = value;
    
    if((path=="criteria" && value==Constants.calculationFilters.calculationUnitFilter.ALL) ||
      (path=="filterGroup" && value!="" && value!=this.state.calculationsFilters.filterGroup)) {
      calculationsFiltersNew.calculationUnitsSelected = [];
    }
    else if(path=="filterPeriod") {
      calculationsFiltersNew.calculationUnitsSelected = [];
      calculationsFiltersNew.criteria = Constants.calculationFilters.calculationUnitFilter.ALL;      
      calculationsFiltersNew.filterGroup = "";
      if(value) {
        this.props.actions.getGroupsList(value);
      }
    }
    
    this.setState({
      calculationsFilters: calculationsFiltersNew
    });    
  };

  handleFindCalculations = (event) => {
    this.state.calculationsFiltersActive = JavascriptUtilsTooling.deepCopy(this.state.calculationsFilters);
    this.state.filtersText = this.getFiltersLegend();
    EntityTableTooling.fetchList(this);    
  };

  handleFiltersCollapse = (event) => {
    this.setState({
      filtersCollapse: !this.state.filtersCollapse
    });
  };

  handleFetchFilterCalculationUnits = async (keyword) => {
    await this.props.actions.getCalculationUnitsList(keyword, this.state.calculationsFilters.filterGroup, this.state.calculationsFilters.filterPeriod);
  };

  handleExportCalculations = async () => {
    await this.props.actions.exportCalculations(EntityTableTooling.getListQueryParams(this));
  };

  getFiltersLegend = () => {
    var filterItemsText = []
    filterItemsText.push(this.state.calculationsFiltersActive.filterGroup ? intl.formatMessage({id: "calculationsHistory.filtersDetailLabels.group"}) + ": " + 
      (this.props.groupsList.data.find(item => item.id==this.state.calculationsFiltersActive.filterGroup)).name : ""
    );
    filterItemsText.push(LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationsHistory.filtersDetailLabels.calculationUnits"})) + ": " + 
      intl.formatMessage({id: "calculationsHistory.calculationUnitFilterCriteria." + this.state.calculationsFiltersActive.criteria}) +
      (this.state.calculationsFiltersActive.calculationUnitsSelected.length>0 ? " -> " +
        this.state.calculationsFiltersActive.calculationUnitsSelected.map(item => item.name).join("; ") : "")
    );
    filterItemsText.push(this.state.calculationsFiltersActive.filterPolynomial ? intl.formatMessage({id: "calculationsHistory.filtersDetailLabels.polynomial"}) + ": " + 
      (this.props.polynomialsList.data.find(item => item.id==this.state.calculationsFiltersActive.filterPolynomial)).name : ""
    );
    filterItemsText.push(this.state.calculationsFiltersActive.filterPeriod ? intl.formatMessage({id: "calculationsHistory.filtersDetailLabels.period"}) + ": " + 
      (this.props.periodsList.data.find(item => item.id==this.state.calculationsFiltersActive.filterPeriod)).name : ""
    );
    filterItemsText.push(this.state.calculationsFiltersActive.showOnlyWithErrorsFilter ? intl.formatMessage({id: "calculationsHistory.filtersDetailLabels.onlyErrors"}) : ""); 
    filterItemsText = filterItemsText.filter(item => item!="").join(" | ");
    return filterItemsText;
  };

  handleCalculationDetailPopup = event => { 
    InterfaceTooling.handleShowPopup(
      event, popupIds.calculationDetailPopup, this.state, 
      this.setState.bind(this), this.props.loadingCalculationDepurationDetail, () => {
        var calculation = JSON.parse(event.currentTarget.dataset.entitydata);
        this.props.actions.getCalculationDepurationDetail({id: calculation.id});
      }
    );
  };

  handleCalculationInstanceDeleteDetailPopup = async (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.deleteCalculationInstancesDetailPopup, this.state, 
      this.setState.bind(this), this.props.calculationInstancesDetail.loading, () => {
        var calculationInstanceActive = JSON.parse(event.currentTarget.dataset.entitydata);
        this.setState({
          activeCalculationInstanceObject: calculationInstanceActive
        });
        this.props.actions.getCalculationInstancesDetail({
          active_calculation_instance_id: calculationInstanceActive.id,
          per_page: Constants.interface.calculationInstancesDetailPageSize,
          page: 1
        });
      }
    );
  };

  handleRefreshCalculationInstanceDeleteDetailPopup = event => { 
    this.props.actions.getCalculationInstancesDetail({
      active_calculation_instance_id: this.state.activeCalculationInstanceObject.id,
      per_page: Constants.interface.calculationInstancesDetailPageSize,
      page: 1
    });
  };

  handleCalculationInstanceDeleteDetailPopupNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.calculationInstancesDetail.status === 200 && this.props.calculationInstancesDetail.page<=this.props.calculationInstancesDetail.totalPages) {
      this.props.actions.getCalculationInstancesDetail({
        active_calculation_instance_id: this.state.activeCalculationInstanceObject.id,
        per_page: Constants.interface.calculationInstancesDetailPageSize,
        page: page
      });
    }  
  };

  handleCalculationInstanceDeleteConfirmPopup = async (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.deleteCalculationInstanceConfirmPopup, this.state, 
      this.setState.bind(this), this.props.deleteCalculationInstance.loading, () => {
        var calculationInstanceId = null;
        if(event.currentTarget.dataset.entitydata) {
          calculationInstanceId = JSON.parse(event.currentTarget.dataset.entitydata).id;
        }
        this.props.actions.prepareDeleteCalculationInstance(calculationInstanceId);
      }
    );
  };
    
  handleCalculationInstanceDeleteConfirmConfirm = async () => {
    if(this.props.deleteCalculationInstance.id) {
      await this.props.actions.deleteCalculationInstance({id: this.props.deleteCalculationInstance.id});
    }
    else if(this.state.activeCalculationInstanceObject) {
      await this.props.actions.deleteCalculationInstance({
        id: this.state.activeCalculationInstanceObject.id,
        delete_all: true
      });
    }
  };

  render() {
    var loadingView = this.props.periodsList.firstLoading || 
        this.props.polynomialsList.firstLoading;
    var errorLoadingView = (this.props.list.status !== null && this.props.list.status !== 200) ||
        (this.props.groupsList.status !== null && this.props.groupsList.status !== 200) ||
        (this.props.periodsList.status !== null && this.props.periodsList.status !== 200) ||
        (this.props.polynomialsList.status !== null && this.props.polynomialsList.status !== 200);
    return (
      <section className="dashboard_content_inner_view entity_admin_container calculations_history_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section className={"left_filter_fixed_section_parent" + (this.state.filtersCollapse ? " left_filter_fixed_section_parent_collapse" : "")}>
              <div className="left_filter_fixed_section">
                <Filters 
                  onChangeFilter={this.handleOnChangeCalculationsFilters}
                  filterValues={this.state.calculationsFilters}
                  groupsData={this.props.groupsList.data}
                  modelsData={this.props.polynomialsList.data}
                  periodsData={this.props.periodsList.data}
                  calculationUnitsData={this.props.calculationUnitsFilter.data}
                  calculationUnitsLoading={this.props.calculationUnitsFilter.loading}
                  calculationUnitsFetchAction={this.handleFetchFilterCalculationUnits}
                  loadingCalculationsButton={this.props.list.loading && this.props.list.paginationStatus==null}
                  loadingGroups={this.props.groupsList.loading}
                  handleLoadCalculations={this.handleFindCalculations}
                  disabledPeriodSelector={this.props.fixedPeriodId!=""}
                />
                <div className="left_filter_fixed_section_collapse_component" onClick={this.handleFiltersCollapse}>
                  <i className={"fas "+ (this.state.filtersCollapse ? "fa-angle-right" : "fa-angle-left")}/>
                </div>
              </div>
              <div className="left_filter_right_section calculations_history_container_data_section">
                <Header
                  disabledExportButton={(this.props.list.firstLoading && !this.props.list.loading) || 
                    (this.props.list.loading && this.props.list.paginationStatus==null)}
                  loadingExportButton={this.props.exportCalculations.loading}
                  handleExportButton={this.handleExportCalculations}
                />
                {(!this.props.list.firstLoading && !this.props.list.loading || this.props.list.paginationStatus!=null) && (
                  <EntityTable
                    entityTableDescriptor={this.state.tableDescriptor}
                    data={this.props.list.data}
                    loading={this.props.list.loading}
                    page={this.props.list.page}
                    totalPages={this.props.list.totalPages}
                    totalRecords={this.props.list.totalRecords}
                    fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                    handleCustomActions={[this.handleCalculationDetailPopup]}
                    handleDelete={this.handleCalculationInstanceDeleteDetailPopup}
                    customActionsIcons={["eye"]}
                    customActionsTooltips={[
                      intl.formatMessage({ id: "calculationsHistory.calculationDetail"})
                    ]}
                    extraControls={(
                      <div className="filters_info" title={this.state.filtersText}>
                        {this.state.filtersText}
                      </div>
                    )}
                    colorConfig={[{
                      color: "red",
                      column: "has_error",
                      value: true
                    }]}
                  />
                )}
                {(this.props.list.firstLoading && !this.props.list.loading) && (
                  <div className="no_metrics_selected_wrapper info_loading_metrics_panel">
                    {intl.formatMessage({ id: "calculationsHistory.noFilters" })}
                  </div>
                )}
                {(this.props.list.loading && this.props.list.paginationStatus==null) && (
                  <div className="loading_metrics_wrapper info_loading_metrics_panel">
                    <Spinner/>
                  </div>
                )}
              </div>
              <CalculationDetailPopupContainer
                popupState={this.state[popupIds.calculationDetailPopup]}
                handleCalculationDetailPopup={this.handleCalculationDetailPopup}
              />
              <DeleteCalculationInstancesDetailPopup
                handleShowPopup={this.handleCalculationInstanceDeleteDetailPopup}
                handleRefresh={this.handleRefreshCalculationInstanceDeleteDetailPopup}
                fullLoading={this.props.calculationInstancesDetail.firstLoading}
                tableLoading={this.props.calculationInstancesDetail.loading}
                calculationInstancesDetailState={this.props.calculationInstancesDetail}
                activeCalculationInstanceObject={this.state.activeCalculationInstanceObject}
                handleCalculationInstancesNextPage={this.handleCalculationInstanceDeleteDetailPopupNextPage}
                handleDeleteCalculationInstance={this.handleCalculationInstanceDeleteConfirmPopup}
                popupState={this.state[popupIds.deleteCalculationInstancesDetailPopup]}
              />
              <GlassConfirmPopup
                confirmTitle={this.props.deleteCalculationInstance.id ? (
                  <FormattedMessage id={"calculationsHistory.deleteCalculationInstanceConfirmTitle"}/>
                ) : (
                  <FormattedMessage id={"calculationsHistory.deleteAllCalculationInstanceDetailConfirmTitle"}/>
                )}
                confirmText={this.props.deleteCalculationInstance.id ? (
                  <FormattedMessage id={"calculationsHistory.deleteCalculationInstanceConfirm"}/>
                ) : (
                  <FormattedMessage id={"calculationsHistory.deleteAllCalculationInstanceDetailConfirm"}/>
                )}
                handleConfirm={this.handleCalculationInstanceDeleteConfirmConfirm}
                handleCancel={this.handleCalculationInstanceDeleteConfirmPopup}
                popupState={this.state[popupIds.deleteCalculationInstanceConfirmPopup]}
                loading={this.props.deleteCalculationInstance.loading}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.calculationsHistory.list,
  groupsList: state.reducer.calculationsHistory.groupsList,
  periodsList: state.reducer.calculationsHistory.periodsList,
  calculationUnitsFilter: state.reducer.calculationsHistory.calculationUnitsFilter,
  polynomialsList: state.reducer.calculationsHistory.polynomialsList,
  exportCalculations: state.reducer.calculationsHistory.exportCalculations,
  calculationInstancesDetail: state.reducer.calculationsHistory.calculationInstancesDetail,
  deleteCalculationInstance: state.reducer.calculationsHistory.deleteCalculationInstance,
  loadingCalculationDepurationDetail: state.reducer.calculationsHistory.calculationDepurationDetail.loading,
  fixedPeriodId: state.reducer.dashboard.fixedPeriodId
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(calculationsHistoryActions, dispatch)
});

CalculationsHistory.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CalculationsHistory);



// WEBPACK FOOTER //
// ./source/client/containers/calculationsHistory/index.jsx